export default __webpack_public_path__ + "static/media/homerImage.2af32d04.png";